import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ACTIVITIES';
export const {
    action: comment,
    success: commentSuccess,
    failed: commentFailed,
} = createAction(
    `${domain}/COMMENT`,
    (originatorId, body) => ({originatorId, body}),
    originatorId => ({originatorId}),
    originatorId => ({originatorId}),
);

export const {
    action: likeComment,
    success: likeCommentSuccess,
    failed: likeCommentFailed,
} = createAction(
    `${domain}/LIKE_COMMENT`,
    (commentId, liked) => ({commentId, liked}),
    commentId => ({commentId}),
    commentId => ({commentId}),
);

export const {
    action: likeActivity,
    success: likeActivitySuccess,
    failed: likeActivityFailed,
} = createAction(
    `${domain}/LIKE_ACTIVITY`,
    (activityId, liked) => ({activityId, liked}),
    activityId => ({activityId}),
    activityId => ({activityId}),
);

export const {action: clearLikeMap} = createAction(`${domain}/CLEAR_LIKE_MAP`, id => ({id}));

export const {
    action: deleteComment,
    success: deleteCommentSuccess,
    failed: deleteCommentFailed,
} = createAction(
    `${domain}/DELETE_COMMENT`,
    commentId => ({commentId}),
    commentId => ({commentId}),
    commentId => ({commentId}),
);

export const {action: reloadActivityList} = createAction(`${domain}/RELOAD_ACTIVITY_LIST`);

export const {
    action: uploadImageFromURL,
    success: uploadImageFromURLSuccess,
    failed: uploadImageFromURLFailed,
} = createAction(
    `${domain}/UPLOAD_IMAGE`,
    (url, cb) => ({url, cb}),
    imageId => ({imageId}),
);
